<template>

    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex xs12 lg10 xl8 offset-lg1 offset-xl2>
                <v-card>
                    <v-card-title>
                        <div class="headline" style="width:100%">{{__('dialogs.success_title')}}</div>
                        <div class="subheading" style="width:100%">{{__('dialogs.success_subtitle', {email: email})}}</div>
                    </v-card-title>
                    <v-card-text>
                        <div v-html="__('dialogs.success_text', {email: event.pl_email})"></div>
                        <v-list two-line>
                            <v-list-tile :href="'mailto:'+company.email" target="_blank">
                                <v-list-tile-action>
                                    <v-icon color="primary">mail</v-icon>
                                </v-list-tile-action>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{company.email}}</v-list-tile-title>
                                    <v-list-tile-sub-title>{{__('dialogs.contact_send_email')}}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                        <div class="small" v-html="__('messages.email_receipts', {email: event.pl_email})"></div>
                        <div class="small">{{__('messages.mail_receipts')}}<a @click="downloadLetterHead">{{__('messages.mail_receipts_link')}}</a>.</div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "Success",
        props: {
            event: Object,
            token: String,
            email: String,
            company: Object
        },
        methods: {

            downloadLetterHead() {
                axios.post('/letterhead/download/'+this.token).then((response) => {
                    let blob = this.b64toBlob(response.data.pdf, 'application/pdf');
                    let fileName = response.data.filename;
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                });
            },
            b64toBlob(b64Data, contentType = '', sliceSize = 512) {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, {type: contentType});
                return blob;
            }
        }
    }
</script>

<style scoped>
    .small {
        font-size: 10px;
    }
</style>
